exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".not-admin .main-nav,.not-admin .open-close-menu,.not-admin .user-menu{display:none}.not-admin main{box-shadow:none}.not-admin main>div{background:transparent}@media screen and (max-width:36.4375em){.not-admin .body__header{width:100%;padding:0 1rem;height:4.5rem}.not-admin .body__header h1{padding:0;line-height:4.5rem}.not-admin .body__header h1 img{height:2.5rem}}@media screen and (min-width:36.5em){.not-admin .body__header{padding:1rem 2rem;width:100%}.not-admin main{width:100%;padding:0 1rem;margin:0}}@media screen and (min-width:47.5em){.not-admin .body__header{padding-left:3.5rem}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/containers/DownloadPage/DownloadPage.scss
// module id = 709
// module chunks = 0